export default "__VITE_ASSET__DXjqVUOh__"